@use '../../../../styles/scss/vcom/mixins/breakpoints';

vs-offer-bundle {
  width: 100%;
}

.vs-offer-bundle {
  max-width: calc(100% - 4px);
  margin: 2px auto 30px auto;

  &[data-layout='content-library'] {
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 540px;

    @include breakpoints.tablet-up {
      max-width: 720px;
    }

    @include breakpoints.desktop-up {
      max-width: calc(0.33 * 960px);
      margin-left: 12%;
      margin-right: 12%;
    }

    @include breakpoints.desktop-plus-up {
      max-width: calc(0.33 * 1140px);
    }
  }

  .vs-offer-bundle-media {
    position: relative;
    display: block;
    max-width: 100%;
    overflow: hidden;
    text-align: center;
    cursor: pointer;

    &:hover {
      & button {
        opacity: 0.9;
      }
    }

    & button:focus {
      opacity: 0.9;
    }

    & .vs-offer-bundle-date,
    & .vs-offer-bundle-header,
    & .vs-offer-bundle-body,
    & .vs-offer-bundle-body p {
      margin-bottom: 10px;
      text-align: left;
    }

    // START GENAI@GHCOPILOT
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        list-style: none;
        padding: 0;
        margin: 0;
        width: auto !important; // Override the inherited width
      }
    }
    // END GENAI@GHCOPILOT
  }

  .vs-offer-bundle-img {
    display: block;
    max-width: 100%;
    width: 100%;
    height: 190px;
    object-fit: cover;
    margin-bottom: 20px;
  }

  .vs-offer-bundle-cta {
    & a {

      &.vs-link-cta,
      &.vs-btn {
        margin-bottom: 20px;
      }

      &.vs-link-cta {
        width: fit-content;
      }
    }
  }

  .vs-offer-bundle-header {
    & a {

      &.vs-link-cta,
      &.vs-btn {
        margin-bottom: 20px;
      }

      &.vs-link-cta {
        width: fit-content;
      }
    }
  }
}

// START GENAI@GHCOPILOT
.contrast-borders {
  @media (forced-colors: active) {
    border: 1px solid currentColor; /* Use the current text color for the border */
  }
}
// END GENAI@GHCOPILOT
